import analytics, { events } from '../../../shared/analytics';
import UiElement from '../../../shared/ui-element/ui-element';

import './side-scrolling-banner.scss';

class SideScrollingBanner extends UiElement {
  ui = {
    ctaButton: '.js-side-scrolling-cta',
    closeButton: '.js-close-side-scrolling',
    banner: '.js-side-scrolling-banner',
    title: '.js-banner-title',
    article: '.article-content',
  };

  events = {
    'click @ui.ctaButton': 'handleCtaButton',
    'click @ui.closeButton': 'handleCloseButton',
  };

  screenHeight = document.documentElement.clientHeight;

  onInit() {
    super.onInit();

    if (this.ui.banner) {
      document.addEventListener('scroll', () => {
        this.handleScroll();
      });
    }
  }

  handleCloseButton() {
    this.ui.banner.remove();
    this.destroy();
  }

  handleCtaButton() {
    const eventLabel = this.ui.banner.dataset.bannerName || this.ui.title.textContent;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'Side-Scroll',
    });
  }

  handleScroll() {
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    const bannerTop = (this.screenHeight - this.ui.banner.offsetHeight) / 2;

    if (scrolled > this.ui.article.offsetTop - bannerTop) {
      this.ui.banner.classList.add('-visible');
    }

    if (scrolled < this.ui.article.offsetTop - bannerTop / 2) {
      this.ui.banner.classList.remove('-visible');
    }

    if (scrolled > this.ui.article.offsetHeight + bannerTop) {
      this.ui.banner.classList.remove('-visible');
    }
  }
}

export default SideScrollingBanner;
